import React from 'react';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SEO from '../components/SEO';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://lrnaicare.net/#organization',
      name: 'lrnaicare.net',
      url: 'https://lrnaicare.net/',
      logo: {
        '@type': 'ImageObject',
        '@id': 'https://lrnaicare.net/#logo',
        url: 'https://lrnaicare.net/logo.webp',
        contentUrl: 'https://lrnaicare.net/logo.webp',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://lrnaicare.net/#website',
      url: 'https://lrnaicare.net/',
      name: 'lrnaicare.net',
      publisher: {
        '@id': 'https://lrnaicare.net/#organization',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://lrnaicare.net/#webpage',
      url: 'https://lrnaicare.net/',
      name: 'lrnaicare.net',
      description:
        'Manage subscriptions, request cancellations, review billing charges, and contact support agents for fast assistance and account help.',
      isPartOf: {
        '@id': 'https://lrnaicare.net/#website',
      },
      publisher: {
        '@id': 'https://lrnaicare.net/#organization',
      },
      about: {
        '@id': 'https://lrnaicare.net/#subscription-support-service',
      },
    },
    {
      '@type': 'Service',
      '@id': 'https://lrnaicare.net/#subscription-support-service',
      name: 'lrnaicare.net Subscription Support Service',
      description:
        'Online service for managing subscriptions, requesting cancellations, reviewing billing charges, and contacting support agents.',
      url: 'https://lrnaicare.net/',
      provider: {
        '@id': 'https://lrnaicare.net/#organization',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="page-shell min-h-screen">
      <SEO
        title="Subscription Support & Cancellation Help | Learnaicare"
        description="Manage subscriptions, request cancellations, review billing charges, and contact support agents for fast assistance and account help."
        canonical="https://lrnaicare.net/"
        ogUrl="https://lrnaicare.net/"
        schema={homeSchema}
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Features />
      </main>
      <Footer />
    </div>
  );
}
